import React, { use, useCallback } from "react";

import { SearchResultItem } from "./M365PulseSearchBox.types";
import { SearchContext } from "./SearchStore";

export const useSearchResultKeyDown = () => {
    const store = use(SearchContext);

    return useCallback(
        (e: React.KeyboardEvent, item: SearchResultItem) => {
            if (e.key === "Escape" || (e.key === "Tab" && !e.shiftKey)) {
                e.preventDefault();
                e.stopPropagation();
                store?.setOpen(false);
                store?.returnFocusToInput();
            } else if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                item.onClick?.();
            } else if (e.key === "Delete" && item.deleteItemFromHistory) {
                e.preventDefault();
                item.deleteItemFromHistory();
            }
        },
        [store]
    );
};
